<template>
  <Container type="card-full" drankColor>
    <!--<div>-->
      <!--<div class="search">-->
        <!--<div class="search_box">-->
          <!--<div class="searchItem">-->
            <!--<div class="label">项目编号</div>-->
            <!--<div class="field">-->
              <!--<el-input v-model.trim="query.projectcode" clearable ></el-input>-->
            <!--</div>-->
          <!--</div>-->
          <!--<div class="searchItem">-->
            <!--<div class="label">项目名称</div>-->
            <!--<div class="field">-->
              <!--<el-input v-model.trim="query.projectname" clearable ></el-input>-->
            <!--</div>-->
          <!--</div>-->
          <!--<div class="searchItem">-->
            <!--<div class="label">状态</div>-->
            <!--<div class="field">-->
              <!--<el-select v-model="query.status" :clearable="true" placeholder="请选择">-->
                <!--<el-option-->
                  <!--v-for="item in projectStatusList"-->
                  <!--:key="item.value"-->
                  <!--:label="item.label"-->
                  <!--:value="item.value">-->
                <!--</el-option>-->
              <!--</el-select>-->
            <!--</div>-->
          <!--</div>-->
          <!--<div class="searchItem">-->
            <!--<div class="search_btn">-->
              <!--<el-button @click="search">查询</el-button>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
      <!--<vggrid :list="list" tableheight="600" flexname="" :cols="cols"-->
              <!--:showfooter="false" :showPage="true" :resizable="true"-->
              <!--:total="query.total" @cellClick="cellClick" @cellDblClick="viewProject" @pagechange="pagechange"></vggrid>-->
    <!--</div>-->
    <el-dialog :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false" @close="close" title="温馨提示：尊敬的用户，您的登录密码是平台初始值，为保证信息安全，请您修改密码" :visible.sync="dialogVisible" width="50%">
      <div>
        <el-form ref="selectrow" label-width="110px" class="fs2em">
          <!--<el-form-item label="用户名">-->
            <!--<span>{{$store.getters.loginUser.username}}-{{$store.getters.loginUser.usermobile}}</span>-->
          <!--</el-form-item>-->
          <!--<el-form-item label="原密码" verify required >-->
            <!--<el-input type="password"  v-model="userpwd"></el-input>-->
          <!--</el-form-item>-->
          <el-form-item label="新密码" verify required >
            <el-input type="password"  v-model="userpwd1"></el-input>
            <div style="color: red">新密码要求是数字和字符的结合，不能少于8位数!</div>
          </el-form-item>
          <el-form-item label="确认密码" verify required >
            <el-input type="password"  v-model="userpwd2"></el-input>
          </el-form-item>
          <el-form-item label="验证码" verify required >
            <div class="row">
              <div class="value"><el-input placeholder="请输入手机验证码" v-model="yzm" clearable></el-input></div>
              <div class="yzmbtn" :class="{gray: sendFlag}" @click="getsms">
                <sec-count-down v-if="sendFlag" @stop="stop">秒后获取</sec-count-down>
                <span  v-else>发送验证码</span>
              </div>

            </div>
          </el-form-item>
          <el-form-item label="" verify required >
            <el-button @click="onSubmit">确定</el-button>
            <el-button @click="exist">退出</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </Container>
</template>
<script>
  import request from '@/utils/request'
  import ElButton from "../../../node_modules/element-ui/packages/button/src/button.vue";
  import Md5 from '../../assets/js/md5'
  import vggrid from '../common/vggrid'
  import config from '../../assets/config'
  import SecCountDown from '../common/secCountDown'
  export default {
    components: {ElButton, SecCountDown, vggrid},
    name: 'mainIndex',
    data () {
      return {
        yzm: '',
        yzmToken: '',
        dialogTitle: '',
        dialogVisible: false,
        userpwd: '',
        userpwd1: '',
        userpwd2: '',
        sendFlag: false,
        isDisabledBtn: false,
        list: [],
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'projectcode', fieldtype: 'C', title: '项目编号',calculExpr:'',addNewRowFlg: false},
          // { field: 'projectno', fieldtype: 'C', title: '平台编号',calculExpr:'',addNewRowFlg: false},
          { field: 'projectname', fieldtype: 'C', title: '项目名称',calculExpr:'',addNewRowFlg: false},
          { field: 'projectstatusname', fieldtype: 'C', title: '状态',calculExpr:'',addNewRowFlg: false},
          { field: 'projecttime', fieldtype: 'T', title: '创建时间',calculExpr:'',addNewRowFlg: false,formatter: ['toDateString', '']}
          ],
        project: {},
        projectStatusList: [],
        query: {
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
      let userpwd = Md5.md5(this.$store.getters.loginUser.usermobile.slice(this.$store.getters.loginUser.usermobile.length - 6))
      console.log(userpwd)
      if (userpwd === this.$store.getters.loginUser.userpassword) {
        // this.dialogVisible = true
      }
      // this.getProjectStatusList()
      // this.getPageList()
    },
    methods: {
      async getProjectStatusList () {
        this.projectStatusList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'projectstatus'}
        })
      },
      search () {
        this.getPageList()
      },
      async cellClick (row) {
        this.project = row.row
      },
      async viewProject(row) {
        this.project = row.row
        this.$router.push({name: 'projectView', params: {projectid: this.project.projectid,tabs: ['bmxx', 'jggg', 'jjbg', 'cjtzs'], type: 1}})
      },
      async getPageList () {
        this.loading = true
        this.query.cosid = this.$store.getters.loginUser.cosid
        let res = await request({
          method: 'get',
          url: '/xmgl/project/getPageListForIndex',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      async getsms () {
        if (this.isDisabledBtn) {
          return
        }
        let res = await request({
          url: '/sms/send',
          method: 'get',
          params: {type: '1', tel: this.$store.getters.loginUser.usermobile}
        })
        this.sendFlag = true
        this.isDisabledBtn = true
        this.yzmToken = res.data
        if (res.issuccess) {
          this.$message.success('验证码获取成功')
        } else {
          this.isDisabledBtn = false
          this.sendFlag = false
          this.$message.error({
            message: '获取验证码失败，请30秒后再重新获取',
            type: "warning"
          })
        }
      },
      stop () {
        this.isDisabledBtn = false
        this.sendFlag = false
      },
      close () {
        this.dialogVisible = true
        this.$alert('尊敬的用户，您的登录密码是平台初始值，为保证信息安全，请您修改密码', '温馨提示')
        return
      },
      async exist () {
        await request({
          method: 'post',
          url: '/token/setCache',
          data: {key: this.$store.state.user.loginUser.cacheToken}
        }).then(() => {
          let cacheToken = this.$store.state.user.loginUser.cacheToken
          this.$store.commit('login_out')
          location.href = `${config.webUrl}/#/login?t=${cacheToken}`
        })
      },
      async onSubmit () {
        var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z!@+-=#*$%_]{8,}$/
        if (!this.userpwd1) {
          this.$message.warning('请录入新密码')
          return
        } else if (!reg.test(this.userpwd1)) {
          this.$message.warning('新密码要求是数字和字符的结合，不能少于8位数!')
          return
        } else if (this.userpwd2!==this.userpwd1) {
          this.$message.warning('新密码与确认密码必须一致')
          return
        }
        let data = await request ({
          url: '/xtgl/user/changePwd',
          method: 'post',
          data: {
            yzm: this.yzm,
            yzmToken: this.yzmToken,
            usercode: this.$store.getters.loginUser.usercode,
            usermobile: this.$store.getters.loginUser.usermobile,
            username: this.$store.getters.loginUser.username,
            // oldpassword: Md5.md5(this.userpwd),
            userpassword: Md5.md5(this.userpwd2),
            userid: this.$store.getters.loginUser.userid
          }
        })
        if (data.issuccess === 1) {
          this.$message.success(data.msg)
          setTimeout(() => {
            this.exist()
          }, 1500)
        } else {
          this.$message.warning(data.msg)
        }
      }
    }
  }
</script>
<style lang="scss" scoped>

  .row {
    display: flex;
    /*align-items: center;*/
    .label {
      width: 60px;
    }
    .value {
      flex: 1;
    }
    .yzmbtn {
      cursor: pointer;
      border: 1px solid #DCDFE6;
      padding: 0 11px;
      margin-left: 10px;
      border-radius: 4px;
      /*color: blue;*/
    }
    .gray {
      color: #C0C4CC;
    }
  }
</style>
